import PropTypes from 'prop-types';

export default PropTypes.shape({
  brandId: PropTypes.number,
  authorName: PropTypes.string,
  createDate: PropTypes.string,
  text: PropTypes.string,
});
